import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconGoogleContacts = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <rect width={75} height={75} x={0.205} fill='#fff' rx={14} />
    <path
      fill='#86A9FF'
      d='M33.738 36.998c-8.235 0-14.898 6.662-14.898 14.898v6.257c0 1.481 1.2 2.682 2.682 2.682h7.15l7.152-23.837z'
    />
    <path
      fill='#578CFF'
      d='M58.17 46.83a9.827 9.827 0 0 0-9.832-9.832h-7.15v23.837h7.15a9.827 9.827 0 0 0 9.833-9.833'
    />
    <path
      fill='#0057CC'
      d='M25.991 46.83a9.827 9.827 0 0 1 9.833-9.832h5.363a9.827 9.827 0 0 1 9.833 9.833v4.171a9.827 9.827 0 0 1-9.833 9.833H28.673c-1.481 0-2.682-1.2-2.682-2.682zM38.506 32.826a9.237 9.237 0 1 0 0-18.474 9.237 9.237 0 0 0 0 18.474'
    />
  </svg>
);
export default SvgIconGoogleContacts;
